import type { FC } from 'react';

import { useUsercentricsStyleInjection } from './use-usercentrics-style-injection';

const STYLE_ID = 'xing-uc-light-theme';

export const LightColorscheme: FC = () => {
  const bgColor = '#ffffff';
  const primaryColor = '#C6F16D';
  const acceptBtnFontColor = '#1D2124';
  const acceptBtnHoverBgColor = '#A7E770';
  const secondaryBtnColor = '#DBE2E6';
  const secondaryBtnFontColor = '#1D2124';
  const secondaryBtnHoverBgColor = '#BCC9D1';
  const fontfamily = 'Xing Sans, helvetica, arial, sans-serif';
  const fontcolor = '#1D2124';
  const anchorlinkColor = '#0698A0';
  const accentColor = '#DBE2E6';

  const customStyle = `
    /* V3 Main Dialog */
    [data-testid="uc-main-dialog"],
    #uc-main-dialog {
      background-color: ${bgColor} !important;
      color: ${fontcolor} !important;
      font-family: ${fontfamily};
    }

    /* V3 Button styles */
    [data-testid="uc-accept-all-button"],
    #accept {
      background-color: ${primaryColor} !important;
      color: ${acceptBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    [data-testid="uc-accept-all-button"]:hover,
    #accept:hover {
      background-color: ${acceptBtnHoverBgColor} !important;
    }

    [data-testid="uc-deny-all-button"],
    #deny {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    [data-testid="uc-deny-all-button"]:hover,
    #deny:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    [data-testid="uc-more-button"],
    #more {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    [data-testid="uc-more-button"]:hover,
    #more:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    [data-testid="uc-save-button"],
    #save {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    [data-testid="uc-save-button"]:hover,
    #save:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    /* V3 Text and backgrounds */
    h1, h2, h3, p, span, div, label {
      color: ${fontcolor} !important;
    }

    a {
      color: ${anchorlinkColor} !important;
      text-decoration: underline;
    }

    /* V3 Tabs */
    [data-testid="uc-tabs-header"],
    #uc-tabs-header {
      background-color: ${bgColor} !important;
    }
    [data-testid="uc-tabs-header"] button,
    #uc-tabs-header button {
      color: ${fontcolor} !important;
      font-family: ${fontfamily};
    }
    [data-testid="uc-tabs-header"] button[aria-selected="true"],
    #uc-tabs-header button[aria-selected="true"] {
      border-bottom-color: ${fontcolor} !important;
    }

    /* V3 Content areas */
    [class*="content"],
    [class*="container"],
    [class*="panel"],
    [class*="list"],
    [class*="card"],
    [class*="header"],
    [class*="footer"],
    [class*="modal"],
    [class*="dialog"],
    [class*="backdrop"] {
      background-color: ${bgColor} !important;
      color: ${fontcolor} !important;
    }

    /* V3 Borders */
    [class*="border"],
    [class*="divider"] {
      border-color: ${accentColor} !important;
    }

    /* Toggle/Switch styling */
    [class*="toggle"],
    [class*="switch"] {
      background-color: ${secondaryBtnColor} !important;
    }

    /* Remove UC Branding via CSS */
    a[href*="usercentrics.com"] {
      display: none !important;
    }
  `;

  useUsercentricsStyleInjection({ customStyle, styleId: STYLE_ID });

  return null;
};
